function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_c('strong',[_vm._v("Experience WhiteBox")])]),_vm._v(" "),_c('p',[_vm._v("Experience first hand what happens behind the scene, in essence play with WhiteBox!")]),_vm._v(" "),_c('p',[_vm._v("To our experience, customer conversion takes time and requires multiple online channels interactions. WhiteBox is a digital sales funnel optimization tool, that tracks, analyzes and reports every single user interaction with your brand. With the help of WhiteBox you could improve your digital sales funnel by optimizing your advertising campaigns, digital presence and customer interactions.")]),_vm._v(" "),_c('p',[_vm._v("During this demo, our goal is getting you to the "),_c('a',{attrs:{"href":"/contacts","title":"Contacts"}},[_vm._v("finish line")]),_vm._v(", where we’d be glad you express interest in WhiteBox. But before that, we’d like to demonstrate the various WhiteBox bits and pieces while tracking all your interactions with us.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/about"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }